import { InvitableMember } from "@/src/models/user.model";
import { CloseCircle } from "iconsax-react-nativejs";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Image, Pressable, Text, View } from "react-native";

type InvitedMemberChipsProps = Readonly<{
  members: InvitableMember[];
  onRemove: (id: string) => void;
}>;
const InvitedMemberChips = ({ members, onRemove }: InvitedMemberChipsProps) => {
  const [showAll, setShowAll] = useState(false);
  const MAX_VISIBLE = 5;
  const visible = showAll ? members : members.slice(0, MAX_VISIBLE);
  const extraCount = members.length - MAX_VISIBLE;

  const { t } = useTranslation();

  return (
    <View className="flex-row flex-wrap gap-2 mt-2">
      {visible.map((member) => (
        <View
          key={member.itemId}
          className="flex-row items-center gap-1 bg-chalk border border-ash-3 rounded-full px-2 py-1"
        >
          {member.profileImageUrl && (
            <Image
              source={{ uri: member.profileImageUrl }}
              className="w-5 h-5 rounded-full"
            />
          )}
          <Text className="text-sm text-onyx">
            {member.displayName ?? member.userName}
          </Text>
          <Pressable
            onPress={() => onRemove(member.itemId)}
            className="rounded-full hover:bg-ash-3"
          >
            <CloseCircle className="text-gray-light-2" />
          </Pressable>
        </View>
      ))}
      {!showAll && extraCount > 0 && (
        <Pressable
          onPress={() => setShowAll(true)}
          className="items-center justify-center bg-primary-light-2 border border-ash-3 rounded-full px-2 py-1 hover:bg-ash-3"
        >
          <Text className="text-sm text-primary underline">{`+${extraCount} ${t("LABEL_MORE")}`}</Text>
        </Pressable>
      )}
      {showAll && members.length > MAX_VISIBLE && (
        <Pressable
          onPress={() => setShowAll(false)}
          className="items-center justify-center bg-primary-light-2 border border-ash-3 rounded-full px-2 py-1 hover:bg-ash-3"
        >
          <Text className="text-sm underline text-primary">
            {t("LABEL_SEE_LESS")}
          </Text>
        </Pressable>
      )}
    </View>
  );
};

export default InvitedMemberChips;
